import { put, takeEvery, all, call, select } from 'redux-saga/effects'
import Wix from 'Wix'
import { SLIDE, MENU } from '../constants'
import { slideActions, menuActions, viewsActions } from '../actions';
import store from '../store'
const getState = (state) => state


function* addAction() {
    yield takeEvery(SLIDE.ADD_ACTION, function* () {
        // сохранение на случай экстренного отключения
        const store = yield select(getState)
        // console.log('getStorage',store);
        localStorage.setItem('text-slider-backUpStorage-'.concat(Wix.Utils.getOrigCompId()), JSON.stringify(store.slideReducer))
    })
    //===================================!!!! SLIDE !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_SLIDE_BACKGROUND, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_SLIDE_HAS_BACKGROUND_SHADOW, function* () { yield put(slideActions.addAction()) })
    // отключил, т.к. буду с этим ещё работать, посмотрю, может опять включу
    // yield takeEvery(SLIDE.CHANGE_SLIDE_BACKGROUND_SHADOW, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CAPTIONS !!!!==========================================

    yield takeEvery(SLIDE.ADD_CAPTION, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.ADD_CAPTION_IN_BOX, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.DELETE_CAPTION, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.DELETE_CAPTION_BY_CAPTION_INDEX, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.PASTE_CAPTIONS, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_ORDER, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_LAYER, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.TOGGLE_CAPTION_HIDE, function* () { yield put(slideActions.addAction()) })
    // yield takeEvery(SLIDE.APPLY_STYLE, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.APPLY_STYLE, function* () { yield put(menuActions.saveTempStyle(null)) })
    yield takeEvery(SLIDE.SET_CAPTION_SIZE, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.SET_CAPTION_SIZE, function* () { yield put(menuActions.updateWorkspaceRandom()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_HAS_SHADOW, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_BUTTON_TEXT_HAS_SHADOW, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.DELETE_LINE, function* () { yield put(slideActions.addAction()) })

    // отключил, т.к. при измененииширины бордера вызывается ADD ACTION повторно 
    // (первый раз ADD ACTION вызывается в компоненте для всех кэпшэнов, а CHANGE_CAPTION_DIMESIONS только для text и button)
    // при массовом изменении бордера или паддинга вызывается несколько раз для каждой капчи
    // yield takeEvery(SLIDE.CHANGE_CAPTION_DIMESIONS, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CHANGE BACKGROUND !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_BACKGROUND_COLOR, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_BACKGROUND_COLOR_HOVER, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CHANGE BORDER !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_BORDER_COLOR, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_BORDER_COLOR_HOVER, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CHANGE FONT !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_CAPTION_BOLD, function* () { yield put(slideActions.addAction()) })
    // yield takeEvery(SLIDE.CHANGE_CAPTION_FONT, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_IS_HOVER, function* () { yield put(slideActions.addAction()) })
    // чтобы ховер применился сразу на капче
    yield takeEvery(SLIDE.CHANGE_IS_HOVER, function* () { yield put(menuActions.updateWorkspaceRandom()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_FONT_COLOR, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_FONT_COLOR_HOVER, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_ITALIC, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_UNDERLINE, function* () { yield put(slideActions.addAction()) })
    // закомментил, т.к. инициализирую ADD_ACTION из компонента
    // yield takeEvery(SLIDE.CHANGE_CAPTION_SHADOW, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_TEXT, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_LINE_TEXT, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_ALIGN, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_TEXT_ALIGN, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_LETTER_CASE, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.TOGGLE_RTL, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CHANGE ANIMATION !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_ANIMATION_IN, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_ANIMATION_OUT, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_ANIMATION_IN_MODE, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_ANIMATION_OUT_MODE, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_ANIMATION_LOOP, function* () { yield put(slideActions.addAction()) })
    // закомментил, т.к. инициализирую ADD_ACTION из компонента
    // yield takeEvery(SLIDE.CHANGE_ANIMATION_DELAY_IN, function* () { yield put(slideActions.addAction()) })
    // yield takeEvery(SLIDE.CHANGE_ANIMATION_DELAY_OUT, function* () { yield put(slideActions.addAction()) })

    //===================================!!!! CHANGE POSITION !!!!==========================================

    yield takeEvery(SLIDE.CHANGE_CAPTION_POSITION, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_SOME_CAPTIONS_POSITION, function* () { yield put(slideActions.addAction()) })
    yield takeEvery(SLIDE.CHANGE_CAPTION_RELATIVE_POSITION, function* () { yield put(slideActions.addAction()) })

    //===================================!!!!! CATCH OUT OF BOUNDS !!!!==========================================
    yield takeEvery(SLIDE.CHANGE_CAPTION_POSITION, catchOutOfBounds)
    yield takeEvery(SLIDE.CHANGE_SOME_CAPTIONS_POSITION, catchOutOfBounds)




    return yield takeEvery(SLIDE.INIT_SLIDE_SETTINGS, function* () { yield put(slideActions.addAction()) })
}

function* historyCleaner() {
    yield takeEvery(MENU.CHANGE_VIEW_TYPE, function* () { yield put(slideActions.clearActionsHistory()) })
    return yield takeEvery(MENU.CHANGE_VIEW_TYPE, function* () { yield put(slideActions.addAction()) })
}

function* selectedArrayCleaner() {
    function* checkCaptionIsExist() {
        const selectedCaptionIndex = store.getState().menuReducer.editingCaptionIndex
        const selectedCaption = store.getState().slideReducer.captions[selectedCaptionIndex]
        // если была удалена выбранная капча, то снимаем выделение и возвращаемся в корень в меню справа
        if (!selectedCaption) {
            yield put(menuActions.clearSelectedCaption())
            if (store.getState().viewsReducer.layersDisplay === 'none' && store.getState().viewsReducer.editSlideSettingsDisplay === 'none') {
                yield put(viewsActions.backToMainMenu())
            }
        }
    }

    yield takeEvery(SLIDE.DELETE_CAPTION, function* () { yield put(menuActions.clearSelectedCaption()) })
    yield takeEvery(SLIDE.DELETE_CAPTION, function* () {
        if (store.getState().viewsReducer.layersDisplay === 'none' && store.getState().viewsReducer.editSlideSettingsDisplay === 'none') {
            yield put(viewsActions.backToMainMenu())
        }
    })
    // пока закомментировал, буду смотреть зачем надо сбрасывать выделение, а то очень неудобно.
    // если это для предотвращения показа устаревших настроек, то для этого поставил key для right panel,
    // который меняется при redo или undo
    // если была удалена выбранная капча
    // yield takeEvery(SLIDE.UNDO, function* () { yield put(menuActions.clearSelectedCaption()) })
    // yield takeEvery(SLIDE.REDO, function* () { yield put(menuActions.clearSelectedCaption()) })
    yield takeEvery(SLIDE.UNDO, function* () { yield call(checkCaptionIsExist) })
    yield takeEvery(SLIDE.REDO, function* () { yield call(checkCaptionIsExist) })
    yield takeEvery(MENU.CHANGE_VIEW_TYPE, function* () { yield put(menuActions.clearSelectedCaption()) })
}


function* captionWidthHeightRefresher() {
    function* changeCaptionDimansion() {
        const viewType = store.getState().menuReducer.viewType;
        const captionSelectedArray = store.getState().menuReducer.captionSelectedArray;
        const captions = store.getState().slideReducer.captions;

        yield captionSelectedArray.map(function* (captionIndex) {
            const { width, height } = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect();
            if (captions[captionIndex].type != 'box') {
                yield put(slideActions.changeCaptionDimesions(captionIndex, { width, height }, viewType))
            }
        })
    }

    yield takeEvery(SLIDE.CHANGE_CAPTION_FONT, setTimeout(() => { changeCaptionDimansion() }, 300))
    yield takeEvery(SLIDE.ADD_CAPTION, function* () { yield call(changeCaptionDimansion) })
    yield takeEvery(MENU.CHANGE_VIEW_TYPE, () => setTimeout(() => { changeCaptionDimansion() }, 300))
}

function* catchOutOfBounds() {
    const store = yield select(getState)
    if (store.menuReducer.viewType !== 'desktop') return
    const indexesToHide = []
    const indexesToShow = []
    const workspaceElem = document.querySelector('#workspace')
    const scale = store.menuReducer.mobileViewScale / 100
    const workspaceElemRect = workspaceElem.getBoundingClientRect()
    const selectedArray = store.menuReducer.captionSelectedArray
    const invisibleBox = document.querySelector('.UnvisibleBox ')
    const renderDebugRect = false
    
    if (renderDebugRect) {
        const captionRectElementsRendered = document.querySelectorAll('.captionRectElementRendered')
        captionRectElementsRendered.forEach(elem => elem.remove())
    }


    selectedArray.map(index => {
        const caption = store.slideReducer.captions[index]
        if (caption.boxId != '') return
        const captionElem = document.querySelector(`#service-${caption.id}`)
        const captionElemRect = {
            left: invisibleBox ? captionElem.getBoundingClientRect().left + (workspaceElemRect.left - invisibleBox.getBoundingClientRect().left) : captionElem.getBoundingClientRect().left,
            top: invisibleBox ? captionElem.getBoundingClientRect().top + (workspaceElemRect.top - invisibleBox.getBoundingClientRect().top) : captionElem.getBoundingClientRect().top,
            width: captionElem.getBoundingClientRect().width,
            height: captionElem.getBoundingClientRect().height
        }
        const isInArray = indexesToHide.includes(index)

        if (renderDebugRect) {
            const captionRectElementRendered = document.createElement('div')
            captionRectElementRendered.style.position = 'absolute'
            captionRectElementRendered.style.top = (captionElemRect.top - workspaceElemRect.top) / scale + 'px'
            captionRectElementRendered.style.left = (captionElemRect.left - workspaceElemRect.left) / scale + 'px'
            captionRectElementRendered.style.width = captionElemRect.width / scale + 'px'
            captionRectElementRendered.style.height = captionElemRect.height / scale + 'px'
            captionRectElementRendered.style.border = '1px solid red'
            captionRectElementRendered.style.zIndex = '999999999999999999999999999999999999'
            captionRectElementRendered.style.pointerEvents = 'none'
            captionRectElementRendered.style.opacity = '1'
            captionRectElementRendered.className = 'captionRectElementRendered'
            workspaceElem.appendChild(captionRectElementRendered)
        }
        
        if (caption) {
            if (captionElemRect.width + captionElemRect.left < workspaceElemRect.left && !isInArray) {
                indexesToHide.push(index)
                return
            }
            if (captionElemRect.height + captionElemRect.top < workspaceElemRect.top && !isInArray) {
                indexesToHide.push(index)
                return
            }
            if (captionElemRect.left > workspaceElemRect.right && !isInArray) {
                indexesToHide.push(index)
                return
            }
            if (captionElemRect.top > workspaceElemRect.bottom && !isInArray) {
                indexesToHide.push(index)
                return
            }
            indexesToShow.push(index)
        }
    })
    if (indexesToHide.length > 0 || indexesToShow.length > 0) {
        yield put(slideActions.hideShowCaptionsOutside(indexesToHide, indexesToShow))
    }
    // }, 300)

}





export function* slideSaga() {
    return yield all([
        addAction(),
        selectedArrayCleaner(),
        historyCleaner(),
    ])
}